<style scoped>
a {
  text-decoration: none;
}
</style>
<template>
  <v-row justify="center" align="center">
    <v-col cols="12" md="8" xl="6" class="pa-4" style="overflow-x: hidden;">
      <div class="text-center mb-2 mt-4">
        <vuetify-logo/>
      </div>

      <v-card>
        <v-card-title>
          <div class="text-h4" style="position: relative; left: 4%; width: 300px;">
            <div style="text-align: start;" class="bold">
              <span style="vertical-align: bottom; display: inline;">ロケモシェア＋</span>
            </div>
            <v-divider color="pink"></v-divider>
            <div style="text-align: start;" class="font-family-Oswald accent--text">Locamo Share Plus</div>
          </div>
        </v-card-title>

        <v-card-title class="text-h5 ml-2 mt-2">
          <v-icon color="accent" large class="mr-2">mdi-map</v-icon>
          マップ一覧
        </v-card-title>
        <v-row v-if="isSignedIn" justify="start" align="start" class="py-2 px-4">
          <h3 class="col-12 ml-4 pb-0 secondary--text">閲覧履歴</h3>
          <v-col v-for="(map,i) of maps.history" :key="i" cols="12" sm="6" md="4">
            <MapCard :map="map"/>
          </v-col>
        </v-row>
        <v-row justify="start" align="start" class="pa-2">
          <h3 class="col-12 ml-4 pb-0 secondary--text">新着マップ</h3>
          <v-col v-for="(map,i) of maps.new" :key="i" cols="12" sm="6" md="4">
            <MapCard :map="map"/>
          </v-col>
        </v-row>
        <v-row justify="start" align="start" class="pa-2">
          <h3 class="col-12 ml-4 pb-0 secondary--text">人気マップ</h3>
          <v-col v-for="(map,i) of maps.popular" :key="i" cols="12" sm="6" md="4">
            <MapCard :map="map"/>
          </v-col>
        </v-row>
        <v-row justify="start" align="start" class="pa-2">
          <h3 class="col-12 ml-4 pb-0 secondary--text">皆で投稿マップ</h3>
          <v-col v-for="(map,i) of maps.allPopru" :key="i" cols="12" sm="6" md="4">
            <MapCard :map="map"/>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <div style="width: 100%; height: 100px;"></div>
  </v-row>
</template>

<script>
import "firebase/storage";
import "firebase/auth";
import 'firebaseui-ja/dist/firebaseui.css';
import VuetifyLogo from '@/components/parts/VuetifyLogo.vue';
import MapCard from "@/components/parts/MapCard";

export default {
  components: {
    MapCard,
    VuetifyLogo
  },
  data: () => ({
    initialized: false,
    maps: {}
  }),
  mounted: function () {
    console.log("mounted");
    // this.$ga.page('/');
    this.$store.commit('set', {
      key: "title",
      val: "TOP"
    });
    // console.log(1243);
    // console.log(this.endFirstAuth);
    if ((this.isSignedIn || this.endFirstAuth) && !this.initialized) {
      this.initialized = true;
      this.init();
    }
  },
  methods: {
    async poster(url, arr, login = true) {
      let token = null;
      if (this.user && this.user.token) {
        token = this.user.token;
      }
      if (!token && login) {
        this.$store.commit('addMessage', {
          text: "この操作にはログインが必要です．"
        });
        return false;
      }
      let params = new URLSearchParams();
      params.append("token", token);
      params.append("data", JSON.stringify(arr));
      return await this.axios.post(url, params).then(response => {
        return response.data;
      }).catch(error => {
        this.$store.commit('addMessage', {
          text: error
        });
        return false;
      });
    },
    init() {
      this.getMaps();
    },
    async getMaps() {
      let res = await this.poster(this.apiRoot + 'top/getMaps.php', {}, false);
      if (!res) {
        this.$store.commit('addMessage', {
          text: "マップの取得に失敗しました．通信環境を確認してください．"
        });
      }
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
      }
      this.maps = res.data;
      // console.log(this.maps);
    },
  },
  computed: {
    user: function () {
      return this.$store.getters.user;
    },
    isSignedIn: function () {
      return this.$store.getters.isSignedIn;
    },
    title: function () {
      return this.$store.getters.get.title;
    },
    imageRoot: function () {
      return this.$store.getters.get.imageRoot;
    },
    apiRoot: function () {
      return this.$store.getters.get.apiRoot;
    },
    endFirstAuth: function () {
      return this.$store.getters.endFirstAuth;
    },
  },
  watch: {
    endFirstAuth: function () {
      if (!this.initialized) {
        this.initialized = true;
        this.init();
      }
    },
    user: function () {
      if (this.initialized) {
        return;
      }
      if (this.user && this.user.rand) {
        console.log("initialized:3");
        this.init();
        this.initialized = true;
      }
    }
  }
};
</script>
